import { Column } from "@/components/Column";
import { Text } from "@/components/Text";
import { SadieStatDelta } from "@/components/tools/sadie-dashboard/SadieStatDelta";
import { Card } from "@ui/card";

import { sadieDashboard } from "@/lib/sadieDashboard";
import {
  SadieDashboardRange,
  SadieDashboardTextMessages,
  SadieStatFormat,
} from "@/types";

// Every text on Sadie's threads in the window, from workers and from Sadie.
export const SadieTextMessagesCard = ({
  range,
  textMessages,
}: {
  range: SadieDashboardRange;
  textMessages: SadieDashboardTextMessages;
}) => {
  /* Helpers */
  const fromWorkers = sadieDashboard.formatValue(
    textMessages.fromWorkers,
    SadieStatFormat.COUNT,
  );
  const fromSadie = sadieDashboard.formatValue(
    textMessages.fromSadie,
    SadieStatFormat.COUNT,
  );

  /* Render */
  return (
    <Card className="p-5">
      <Column className="gap-3">
        <Column className="gap-0.5">
          <Text className="font-plex-mono text-[9px] font-medium uppercase tracking-wider text-slate-500">
            Activity
          </Text>
          <Text className="text-sm font-semibold text-slate-900">
            Text messages
          </Text>
        </Column>
        <Text className="text-3xl font-semibold text-slate-900">
          {sadieDashboard.formatValue(
            textMessages.total,
            SadieStatFormat.COUNT,
          )}
        </Text>
        <SadieStatDelta
          format={SadieStatFormat.COUNT}
          range={range}
          stat={textMessages.total}
        />
        <Text className="text-xs font-normal text-slate-500">
          {fromWorkers} from workers and {fromSadie} from Sadie
        </Text>
      </Column>
    </Card>
  );
};
